import { defineFetcher } from "~/api/_common/defineFetcher"
import { GET } from "~/api/_common/http"

import { Magazine } from "./_types"

const PATH = "/magazines"

export type GetMagazinesQuery = {
  company_id?: number
}

type OmittedMagazine = Omit<Magazine, "content">

export type GetMagazines = {
  current_page: number
  data: OmittedMagazine[]
  last_page: number
  per_page: number
  to: number
  total: number
}

export const fetchGetMagazines = defineFetcher((query?: GetMagazinesQuery): Promise<GetMagazines> => {
  return GET(PATH, query)
})

// Generated by https://quicktype.io
